/* eslint react/prefer-stateless-function: 0 */

/*
* DataLayer component that displays an image overlay with the given bounds.
* Moreover it renders a Geojson layer if its defined in the passed config.
*/

import React from 'react';

import {
  ImageOverlay as LeafletImageOverlay,
  GeoJson as LeafletGeojson,
  LayerGroup as LeafletLayerGroup
} from 'react-leaflet';

import wrapDataLayer from './Utils/Wrapper';

import * as Constants from './Utils/Constants';
import LayerCreator from './Utils/LayerCreator';
import { bufferTiles, getClosestTimeSteps } from '../TimingHandler/TimingUtils';

const shapeDefaultStyle = {
  fill: false,
  color: '#054798',
  weight: 1,
  dashArray: '3, 2'
};

let keyIndex = 0;

class ImageLayer extends React.Component {
  constructor(props) {
    super();
    this.layerCreator = null;
    this.bufferLayer = false;
    this.imageLayers = [];

    this.geojsonShape = props.config.bounds.shape ?
      <LeafletGeojson
        data={props.config.bounds.shape}
        style={props.config.bounds.style || shapeDefaultStyle}
      /> : null;
  }

  componentWillMount() {
    const { props } = this;
    const bounds = [
      props.config.bounds.ur.slice(0).reverse(),
      props.config.bounds.ll.slice(0).reverse()
    ];
    this.layerCreator = new LayerCreator(this.createImageLayer(bounds), 'file');

    if (!props.timeConnected) {
      const currentTimestampIndex = getClosestTimeSteps(props.config.runs[0].timesteps, +new Date()).nearestTimestep.index || 0;
      const imgLayer = this.createImageLayer(bounds)({
        url: `${Constants.TILE_HOST}${props.config.runs[0].timesteps[currentTimestampIndex].file}`,
        opacity: props.opacity || 0.8
      });

      this.imageLayers = [imgLayer];

      return false;
    }

    this.bufferLayer = bufferTiles(
      props.config.runs[0].timesteps,
      props.leafletMap,
      'imageOverlay',
      'file',
      props.store,
      props.toggleLoadingApp
    );

    const initialValues = this.layerCreator.initLayers(props);
    this.imageLayers = initialValues.layers;
    this.currentIndex = initialValues.currentIndex;
  }

  componentWillUpdate(nextProps) {
    // when all tiles got buffered, we don't call bufferTiles func again
    if (!nextProps.timeConnected) {
      return false;
    }

    if (nextProps.tilesLoaded.every(t => t)) {
      return false;
    }

    // when user clicks on progress bar while buffering, we start buffering from that point
    if (this.props.currentTimestamp !== nextProps.currentTimestamp) {
      this.bufferLayer = bufferTiles(
        this.props.config.runs[0].timesteps,
        this.props.leafletMap,
        'imageOverlay',
        'file',
        this.props.store,
        this.props.toggleLoadingApp
      );
    }
  }

  componentWillUnmount() {
    if (this.bufferLayer) {
      this.bufferLayer.clearAllEventListeners();
    }
  }

  createImageLayer(bounds) {
    return (props) => {
      const key = props.url !== ' ' ? props.url : keyIndex++;
      return (
        <LeafletImageOverlay
          bounds={bounds}
          opacity={typeof props.opacity === 'undefined' ? 0 : props.opacity}
          url={props.url}
          key={`ImageLayer_${key}`}
        />);
    };
  }

  render() {
    this.currentIndex = this.layerCreator.updateLayers(
      this.imageLayers, this.currentIndex, this.props
    );

    return (
      <LeafletLayerGroup>
        {this.imageLayers}
        {this.geojsonShape}
      </LeafletLayerGroup>
    );
  }
}

ImageLayer.propTypes = {
  beforeCount: React.PropTypes.number,
  afterCount: React.PropTypes.number,
  timeConnected: React.PropTypes.bool
};

ImageLayer.defaultProps = {
  beforeCount: 5,
  afterCount: 5,
  timeConnected: false
};

export { ImageLayer as ImageLayerRaw };
export default wrapDataLayer(ImageLayer);



/** WEBPACK FOOTER **
 ** ./core_components/DataLayer/ImageLayer.js
 **/